// vertical-slideshow.js — Vertical everywhere + adaptive height on mobile + mousewheel on desktop
(function ($) {
  $(function () {
    var $slider = $('.slideshow');
    if (!$slider.length) return;

    // Init slick (vertical everywhere)
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: true,
      verticalSwiping: true,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: false
    });

    // === Adaptive height fix for mobile ===
    function setSlideHeight() {
      if (window.innerWidth <= 767) {
        var $current = $slider.find('.slick-current img');
        if ($current.length) {
          var imgH = $current.height();
          if (imgH > 0) {
            $slider.find('.slick-list, .slick-track, .slick-slide').css('height', imgH + 'px');
          }
        }
      } else {
        // reset to full screen on desktop
        $slider.find('.slick-list, .slick-track, .slick-slide').css('height', '100vh');
      }
    }

    // Run after init + on resize + after each slide change
    $slider.on('setPosition afterChange', setSlideHeight);
    $(window).on('resize orientationchange', setSlideHeight);
    setTimeout(setSlideHeight, 800);

    // === Mouse wheel navigation (desktop only) ===
    $slider.on('wheel', function (e) {
      if (window.innerWidth <= 767) return; // skip on mobile

      var slickObj = $slider.slick('getSlick');
      if (!slickObj) return;

      var current = slickObj.currentSlide;
      var total = slickObj.slideCount;
      var delta = e.originalEvent.deltaY;

      if (delta < 0) {
        // scroll up
        if (current === 0) {
          // let page scroll
          return;
        } else {
          e.preventDefault();
          $slider.slick('slickPrev');
        }
      } else {
        // scroll down
        if (current === total - 1) {
          // let page scroll
          return;
        } else {
          e.preventDefault();
          $slider.slick('slickNext');
        }
      }

      
    });
  });
})(jQuery);
